(() => {
  const key = 'traffi:form-confirmation:';
  const lifetime = 30 * 60 * 1000;
  let routes;
  try {
    routes = JSON.parse(document.getElementById('hubspot-thank-you-routes')?.textContent || '[]');
  } catch (_) { return; }
  // Only page-picker destinations on this storefront are eligible.
  function destination(value) {
    if (typeof value !== 'string' || !value.startsWith('/') || value.startsWith('//')) return null;
    const url = new URL(value, window.location.origin);
    return url.origin === window.location.origin && /\/pages\/[^/]+\/?$/.test(url.pathname) ? url : null;
  }
  const page = document.querySelector('[data-form-thank-you]');
  if (page) {
    let allowed = Boolean(window.Shopify?.designMode);
    try {
      const raw = sessionStorage.getItem(key + window.location.pathname);
      if (raw) {
        const receipt = JSON.parse(raw);
        const age = Date.now() - receipt.time;
        allowed ||= age >= 0 && age < lifetime && routes.some(route =>
          route.formId === receipt.formId && destination(route.url)?.pathname === window.location.pathname);
        if (!allowed) sessionStorage.removeItem(key + window.location.pathname);
      }
    } catch (_) { /* Direct-visit content remains available when storage is blocked. */ }
    page.querySelector('[data-confirmation]').hidden = !allowed;
    page.querySelector('[data-confirmation-unavailable]').hidden = allowed;
  }
  let navigating = false;
  function redirect(formId) {
    if (navigating || window.Shopify?.designMode) return;
    const matching = routes.filter(route => route.formId === formId);
    if (matching.length !== 1) return;
    const url = destination(matching[0].url);
    if (!url) return;
    try {
      sessionStorage.setItem(key + url.pathname, JSON.stringify({formId, time: Date.now()}));
      const preview = new URL(window.location.href).searchParams.get('preview_theme_id');
      if (preview && /^\d+$/.test(preview)) url.searchParams.set('preview_theme_id', preview);
      navigating = true;
      window.location.assign(url.href);
    } catch (_) { /* Preserve the inline confirmation when storage is unavailable. */ }
  }
  window.addEventListener('hs-form-event:on-submission:success', event => {
    try {
      const form = window.HubSpotFormsV4?.getFormFromEvent(event);
      if (!form || form.getFormId() !== event.detail?.formId || !form.getConversionId()) return;
      if (form.getRedirectUrl()) return;
      redirect(form.getFormId());
    } catch (_) { /* Keep HubSpot's confirmation available if its API fails. */ }
  });
  // Legacy embeds publish successful submissions from the host window.
  // Restrict messages to this origin/source and a form actually rendered here.
  window.addEventListener('message', event => {
    const data = event.data;
    if (event.origin !== window.location.origin || event.source !== window ||
        data?.type !== 'hsFormCallback' || data.eventName !== 'onFormSubmitted' ||
        typeof data.id !== 'string' || data.data?.redirectUrl) return;
    const forms = [...document.querySelectorAll('form[data-form-id]')];
    for (const frame of document.querySelectorAll('iframe.hs-form-iframe')) {
      try { forms.push(...frame.contentDocument.querySelectorAll('form[data-form-id]')); } catch (_) { /* Cross-origin forms use the V4 listener. */ }
    }
    if (forms.some(form => form.dataset.formId === data.id)) redirect(data.id);
  });
})();
